import withGoogleMap from "react-google-maps/lib/withGoogleMap";
import GoogleMap from "react-google-maps/lib/GoogleMap";
import React from "react";

const MyMapComponent = withGoogleMap(
  ({ onMapLoad, ...props}) => <GoogleMap
    defaultZoom={8}
    defaultCenter={{ lat: 46.9650572, lng: 8.3817774 }}
    ref={onMapLoad}
    {...props}
  />
);

const MyGoogleMap = (props) => (
  <MyMapComponent
    // googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${Config.googleMapsApiKey}&v=3.exp&libraries=geometry,drawing,places`}
    loadingElement={<div style={{ height: `100%` }} />}
    containerElement={<div style={{ height: `400px` }} />}
    mapElement={<div style={{ height: `100%` }} />}
    {...props}
  />
);

export default MyGoogleMap;


// WEBPACK FOOTER //
// ./app/used/requests/MyGoogleMap.js